export const modeloOptions = ['B2B', 'B2C']
export const faturamentoOptions = ['<20k', '20-50k', '50-100k', '100-300k', '300k+']

export const OCUPACAO_COLORS: Record<string, { bg: string; border: string; text: string; label: string }> = {
  deal: { bg: 'rgba(239, 68, 68, 0.08)', border: 'rgba(239, 68, 68, 0.3)', text: '#f87171', label: 'Em Negociação Ativa' },
  closer: { bg: 'rgba(245, 158, 11, 0.08)', border: 'rgba(245, 158, 11, 0.3)', text: '#fbbf24', label: 'Com Closer' },
  bdr: { bg: 'rgba(16, 185, 129, 0.08)', border: 'rgba(16, 185, 129, 0.3)', text: '#34d399', label: 'Com BDR' },
}
